import { render, staticRenderFns } from "./rotary_list.vue?vue&type=template&id=34874126&scoped=true&"
import script from "./rotary_list.vue?vue&type=script&lang=js&"
export * from "./rotary_list.vue?vue&type=script&lang=js&"
import style0 from "./rotary_list.vue?vue&type=style&index=0&id=34874126&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34874126",
  null
  
)

export default component.exports